import React, { useState } from 'react';
import MainNavigation from '../../components/ui/MainNavigation';

import NavigationBreadcrumb from '../../components/ui/NavigationBreadcrumb';
import HeroSection from './components/HeroSection';
import CategoryNavigation from './components/CategoryNavigation';
import ContentGrid from './components/ContentGrid';
import FilterSection from './components/FilterSection';

const SustainabilityKnowledgeHub = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedDifficulty, setSelectedDifficulty] = useState('all');
  const [selectedCostRange, setSelectedCostRange] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  const breadcrumbItems = [
    { label: 'Home', path: '/' },
    { label: 'Knowledge Hub', path: '/sustainability-knowledge-hub' }
  ];

  return (
    <div className="min-h-screen bg-background">
      <MainNavigation />
      
      <div className="pt-16 lg:pt-0 lg:ml-[72px]">
        <NavigationBreadcrumb items={breadcrumbItems} />
        
        <HeroSection 
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
        />
        
        <CategoryNavigation 
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
        />
        
        <FilterSection
          selectedDifficulty={selectedDifficulty}
          setSelectedDifficulty={setSelectedDifficulty}
          selectedCostRange={selectedCostRange}
          setSelectedCostRange={setSelectedCostRange}
        />
        
        <ContentGrid 
          selectedCategory={selectedCategory}
          selectedDifficulty={selectedDifficulty}
          selectedCostRange={selectedCostRange}
          searchQuery={searchQuery}
        />
      </div>
    </div>
  );
};

export default SustainabilityKnowledgeHub;